import React from 'react';

const Logo = (props) => <img className="logo" alt="Logo" src="./static/images/logo.png" {...props} />;

export default Logo;
